import React from 'react';
import { Link } from 'react-router-dom';
import pageHeaderBg from '../assets/images/page-header-bg.jpg';

function Privacy() {
  return (
    <div className="privacy-page">
      <section className="page-header parallaxie" style={{backgroundImage: `url(${pageHeaderBg})`}}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-2" data-cursor="-opaque">Privacy Statement</h1>
                <nav className="wow fadeInUp">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item"><Link to="/">home</Link></li>
                    <li className="breadcrumb-item active" aria-current="page">privacy statement</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="page-content">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="privacy-content">
                <div className="section-title">
                  <div style={{marginBottom: '40px'}}></div>
                </div>

                <div className="privacy-section">
                  <h3>1. What Information We Collect</h3>
                  <p>When you use Hello Truck (COVAI HELLO TRUCK PRIVATE LIMITED), we collect some basic information from you so we can provide the best service possible:</p>
                  <ul>
                    <li><strong>Personal Details:</strong> Like your name, mobile number, email, and pickup/drop addresses.</li>
                    <li><strong>Booking Information:</strong> What type of truck you booked, where it needs to go, and when.</li>
                    <li><strong>Location Data:</strong> With your permission, we use GPS to track your location so we can match you with the closest available truck.</li>
                    <li><strong>Device Info:</strong> We collect information like your IP address, browser type, and how you use our website or app.</li>
                  </ul>
                </div>

                <div className="privacy-section">
                  <h3>2. Why We Collect This Information</h3>
                  <p>We use your information for the following reasons:</p>
                  <ul>
                    <li>To book trucks and assign drivers.</li>
                    <li>To send updates about your trip, like driver contact or arrival time.</li>
                    <li>To improve our service and make Hello Truck faster and easier to use.</li>
                    <li>To follow government rules and safety regulations.</li>
                  </ul>
                </div>

                <div className="privacy-section">
                  <h3>3. Who We Share Your Information With</h3>
                  <p>We respect your privacy and never sell your personal data. However, we may share it with:</p>
                  <ul>
                    <li>Our partner drivers and delivery staff so they can complete your booking.</li>
                    <li>Government authorities, if required by law (e.g., police or court orders).</li>
                  </ul>
                </div>

                <div className="privacy-section">
                  <h3>4. How We Keep Your Information Safe</h3>
                  <p>We take data protection seriously. Your information is stored securely and protected using encryption and other industry best practices. But please remember, no system is completely foolproof.</p>
                </div>

                <div className="privacy-section">
                  <h3>5. Your Rights and Choices</h3>
                  <p>You have full control over your personal data:</p>
                  <ul>
                    <li>You can ask to see the data we have about you.</li>
                    <li>You can ask us to correct or delete it (unless we're required by law to keep it).</li>
                    <li>You can contact us any time at <a href="mailto:support@hellotruck.in">support@hellotruck.in</a> with questions or concerns about your privacy.</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Privacy;
